import { t } from 'i18next'
import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const TITLE = 'title'
const TEXT = 'text'

/**
 * Form model
 */
const formModel = () => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [TEXT]: {
      label: `${t('common.text')}`,
      name: TEXT,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
  [TEXT]: '',
}
/**
 * Form data validation
 */
 export const validationSchema = () =>
 yup.object().shape({
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
    [TEXT]: yup.string().required(`${t('errors.required-error-message')}`),
 })

export default formModel
